<template>
    <div class="completeness-container">
        <div class="progress-bar">
            <div 
                class="progress" 
                :style="{ width: `${completeness}%` }"
                :class="{ 
                    'low': completeness < 40,
                    'medium': completeness >= 40 && completeness < 80,
                    'high': completeness >= 80 
                }"
            ></div>
        </div>
        <div class="completeness-info">
            <span class="percentage">{{ completeness }}% Complete</span>
            <div v-if="missingFields.length > 0" class="missing-fields">
                <p>Consider adding:</p>
                <ul>
                    <li v-for="field in missingFields" :key="field.key">
                        {{ field.label }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';

export default {
    name: 'ProfileCompleteness',
    props: {
        profile: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const fieldDefinitions = [
            { key: 'firstName', label: 'First Name', weight: 10, required: true },
            { key: 'lastName', label: 'Last Name', weight: 10, required: true },
            { key: 'displayName', label: 'Display Name', weight: 5, required: true },
            { key: 'title', label: 'Job Title', weight: 5, required: false },
            { key: 'companyName', label: 'Company Name', weight: 10, required: false },
            { key: 'companyWebsite', label: 'Company Website', weight: 5, required: false },
            { key: 'companyLogoUrl', label: 'Company Logo', weight: 5, required: false },
            { key: 'companyBio', label: 'Company Bio', weight: 10, required: false },
            { key: 'businessArea', label: 'Business Area', weight: 10, required: false },
            { key: 'phone_number', label: 'Phone Number', weight: 5, required: false },
            { key: 'bio', label: 'Personal Bio', weight: 5, required: false },
            { key: 'idealCustomer', label: 'Ideal Customer', weight: 10, required: false },
            { key: 'avoidReferring', label: 'Avoid Referring', weight: 5, required: false },
            { key: 'linkedinUrl', label: 'LinkedIn Profile', weight: 5, required: false }
        ];

        const completeness = computed(() => {
            let score = 0;
            fieldDefinitions.forEach(field => {
                if (field.key === 'phone_number' && props.profile.phone_number) {
                    score += field.weight;
                } else if (props.profile[field.key]) {
                    score += field.weight;
                }
            });
            return Math.min(100, Math.round(score));
        });

        const missingFields = computed(() => {
            return fieldDefinitions.filter(field => {
                if (field.key === 'phone_number') {
                    return !props.profile.phone_number;
                }
                return !props.profile[field.key];
            });
        });

        return {
            completeness,
            missingFields
        };
    }
};
</script>

<style scoped>
.completeness-container {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.progress-bar {
    background: #e9ecef;
    height: 8px;
    border-radius: 4px;
    margin-bottom: 10px;
}

.progress {
    height: 100%;
    border-radius: 4px;
    transition: width 0.3s ease;
}

.progress.low {
    background-color: #dc3545;
}

.progress.medium {
    background-color: #ffc107;
}

.progress.high {
    background-color: #28a745;
}

.completeness-info {
    font-size: 0.9em;
}

.percentage {
    font-weight: bold;
}

.missing-fields {
    margin-top: 10px;
}

.missing-fields p {
    margin: 0;
    color: #6c757d;
}

.missing-fields ul {
    margin: 5px 0 0 0;
    padding-left: 20px;
}

.missing-fields li {
    color: #6c757d;
    margin-bottom: 2px;
}
</style> 